import {useRoute} from '@react-navigation/native';
import {Div, HeaderBack} from 'components';
import {Ecolors} from 'constant';
import React from 'react';
import {ScrollView} from 'react-native-gesture-handler';
import {useAppSelector} from 'store/hooks';
import {Log} from 'utils';
import CardSignature from './CardSignature';
import RowButtonAction from './RowButtonAction';

function DigitalSignatureIPOScreen() {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const {statusScreen} = useAppSelector(state => state.authen);

  const {investmentProfile} = currentUser;
  const route = useRoute<any>();
  Log('adsa', route);

  return (
    <Div backgroundColor={Ecolors.whiteColor} height={'100%'}>
      <HeaderBack
        isHideBack={!!route.params?.isHideBack}
        type={2}
        title={`digitalsignatureipo.giaydangkymuaipo`}
      />
      <ScrollView>
        <Div alignItems={'center'} flex={1}>
          <CardSignature data={route?.params?.data} />
        </Div>
      </ScrollView>
      <RowButtonAction flowApp={route?.params?.flowApp} />
    </Div>
  );
}

export default React.memo(DigitalSignatureIPOScreen);
